var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.597,
    height: 115,
    viewBox: "0 0 115.597 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1 -1.32)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 11.187,
    cy: 11.187,
    r: 11.187,
    transform: "translate(92.359 2.588)",
    fill: "#7bc1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M54,27.458V23.729a3.729,3.729,0,1,1,7.458,0v3.729",
    transform: "translate(45.816 16.148)",
    fill: "#99f69e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M22.458,47,15,74.967h7.458L33.645,52.593,46.7,63.78V74.967l7.458-9.322V58.187L44.831,47",
    transform: "translate(12.102 39.489)",
    fill: "#7bc1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M5,49.593V44H16.187v5.593",
    transform: "translate(3.458 36.895)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M2,47H24.374V60.051H2Z",
    transform: "translate(0.864 39.489)",
    fill: "#dc661e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M24.374,47c0,3.1-5.015,5.593-11.187,5.593S2,50.1,2,47",
    transform: "translate(0.864 39.489)",
    fill: "#eaa378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M10.323,52.95,22.256,42.341a7.458,7.458,0,0,1,3.915-1.864l21.087-3.02A7.458,7.458,0,0,0,51.9,35l6.4-7.458a4.227,4.227,0,0,1,6.787,5L57.494,44.579,51.9,50.172V65.088H25.8V50.172L15.562,58.954a3.984,3.984,0,0,1-5.239-6Z",
    transform: "translate(6.898 21.401)",
    fill: "#2398ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 7.458,
    cy: 7.458,
    r: 7.458,
    transform: "translate(36.425 39.877)",
    fill: "#7bc1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M58.593,5l1.734,3.673,3.859.6-2.8,2.871.653,4.046-3.449-1.92-3.449,1.92.653-4.046L53,9.27l3.859-.6Z",
    transform: "translate(44.952 3.181)",
    fill: "#fff200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M109.139,37.539a5.593,5.593,0,0,0-3.729-5.258V24.339a12.939,12.939,0,0,0,2.2-.5l-1.156-3.542a9.49,9.49,0,0,1-1.044.261V18.279l.69.392a1.872,1.872,0,0,0,2.741-1.976l-.5-3.114,2.144-2.144a1.789,1.789,0,0,0-.97-3.114l-2.871-.429-1.305-2.778a1.864,1.864,0,0,0-3.393,0l-1.305,2.778-2.871.429A1.846,1.846,0,0,0,96.7,11.437l2.144,2.2-.5,3.114a1.864,1.864,0,0,0,2.741,1.864l.69-.392V20.5a8.5,8.5,0,0,1-.988-.242l-1.137,3.561a11.671,11.671,0,0,0,2.125.466v7.943a5.593,5.593,0,0,0-3.822,5.314V39.4H94.223a1.864,1.864,0,0,0-1.864,1.864V55.494L81.619,68.023a1.865,1.865,0,0,0-.317.522L80.258,71.1,71.7,55.4l1.864-2.89a6.04,6.04,0,0,0-8.036-8.483L60.495,34.8l-3.281,1.864,5.5,10.068L57.4,52.939A5.593,5.593,0,0,1,53.951,54.8L32.789,57.75a9.322,9.322,0,0,0-4.866,2.256L15.916,70.615a5.854,5.854,0,0,0-1.864,4.214,5.948,5.948,0,0,0,.28,1.864H8.458a1.864,1.864,0,0,0-1.864,1.864v3.729H2.864A1.864,1.864,0,0,0,1,84.151V97.2a1.864,1.864,0,0,0,1.864,1.864H25.238A1.864,1.864,0,0,0,27.1,97.2V84.151a1.864,1.864,0,0,0-1.864-1.864H21.509V80.571a6.041,6.041,0,0,0,2.163-1.137l7.16-6.153v10.87A1.864,1.864,0,0,0,32.155,85.9l-6.488,24.35H1v3.729H58.8a1.864,1.864,0,0,0,1.4-.634L73.248,98.432a1.64,1.64,0,0,0,.336-.541L84.658,70.2,95.64,57.4a1.864,1.864,0,0,0,.447-1.212V43.132H116.6V39.4h-7.458ZM10.322,80.422H17.78v1.864H10.322ZM23.374,95.337H4.729V89.464a18.98,18.98,0,0,0,9.322,2.144,18.98,18.98,0,0,0,9.322-2.144ZM21.9,86.015a15.009,15.009,0,0,1-7.849,1.864A15.009,15.009,0,0,1,6.2,86.015Zm9.583-18.2L21.248,76.693a2.125,2.125,0,0,1-3.505-1.678,2.032,2.032,0,0,1,.708-1.51L30.4,62.9a5.388,5.388,0,0,1,2.927-1.361l21.087-3.114a9.322,9.322,0,0,0,5.761-3.151l6.4-7.458a2.293,2.293,0,0,1,1.7-.82,2.237,2.237,0,0,1,1.753.671,2.368,2.368,0,0,1,.336,2.927L62.9,62.467l-5.444,5.444a1.864,1.864,0,0,0-.522,1.324V82.286H34.56V69.235a1.862,1.862,0,0,0-3.076-1.417Zm25.45,42.435H37.581l8.763-17.545,10.59,9.08Zm7.458-7.458-3.729,4.27v-6.134a1.865,1.865,0,0,0-.653-1.417L46.959,88.327a1.822,1.822,0,0,0-2.871.541L33.4,110.253H29.526L36,86.015H56.058l8.334,9.994Zm5.836-6.675-2.107,2.517v-3.3a1.864,1.864,0,0,0-.429-1.193l-7.458-8.893a1.864,1.864,0,0,0,.429-1.1V70l5.053-5.034.261-.336,3.468-5.593,9.024,16.575Zm31.864-84.684a1.864,1.864,0,0,0,1.454-1.119v0a1.864,1.864,0,0,0,1.417,1.044h.28l-.28.261a1.864,1.864,0,0,0-.5,1.6v.261h-.112a1.864,1.864,0,0,0-1.864,0h-.112v-.261a1.865,1.865,0,0,0-.5-1.6l-.056-.186ZM105.41,39.4h-3.729V37.539a1.864,1.864,0,1,1,3.729,0Z",
    transform: "translate(0 2.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M28.322,21a9.322,9.322,0,1,0,9.322,9.322A9.322,9.322,0,0,0,28.322,21Zm0,14.916a5.593,5.593,0,1,1,5.593-5.593A5.593,5.593,0,0,1,28.322,35.916Z",
    transform: "translate(15.56 17.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M57.973,4.9,56.78,1.36a13.051,13.051,0,0,0-6.47,4.773l3.02,2.181A9.527,9.527,0,0,1,57.973,4.9Z",
    transform: "translate(42.627 0.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M54.593,13.593A9.322,9.322,0,0,1,52.729,8H49a12.921,12.921,0,0,0,2.536,7.644Z",
    transform: "translate(41.494 5.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M61.864,8.078A9.322,9.322,0,0,1,60,13.541l3.02,2.2a13.051,13.051,0,0,0,2.573-7.663V7.91Z",
    transform: "translate(51.003 5.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M58.619,1.32,57.5,4.881a9.322,9.322,0,0,1,4.661,3.3l2.983-2.219A13.051,13.051,0,0,0,58.619,1.32Z",
    transform: "translate(48.842 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M46,15h3.729v3.729H46Z",
    transform: "translate(38.901 11.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M46,19h3.729v3.729H46Z",
    transform: "translate(38.901 15.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M48,17h3.729v3.729H48Z",
    transform: "translate(40.63 13.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M44,17h3.729v3.729H44Z",
    transform: "translate(37.172 13.555)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDedication);
export default __webpack_public_path__ + "static/media/dedication.5acab08d8f1056513ed9b38e80e7907a.svg";
export { ForwardRef as ReactComponent };